import Vue from 'vue'

// 使用全部Vant组件
import Vant from 'vant'
import 'vant/lib/index.css'
export default {
  init: () => {
    Vue.use(Vant)
  }
}



// WEBPACK FOOTER //
// ./src/config.js